// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const DetailPageConfig = () => (function(config: any) {
   const values = config.detail_page

   return {
      aiPrimaryAction: values.a_i_primary_action,
      enableIll: values.enable_ill,
      enablePrimaryButton: values.enable_primary_button,
      enableSecondaryButton: values.enable_secondary_button,
      enableReserveLinks: config.sierra?.api_integration_enabled ? false : values.enable_reserve_links,
      illBaseUrl: values.ill_base_url,
      messages: values.messages,
      reserveLinks: values.reserve_links,
      sections: values.sections,
      syndeticsClient: config.info.syndeticsClient,
      enableTransliterations: config.site.enable_transliterations
   }
})

angular.module('summonApp.factories.configs')
   .factory('detailPageConfig', DetailPageConfig)
